import { ChangeEvent, useState } from 'react'
import styles from '../../AdminTools.module.css'

interface HeaderAlignedDurationProps {
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

export const HeaderAlignedDuration = ({
  value,
  onChange,
  disabled,
}: HeaderAlignedDurationProps) => {
  const [durationUnit, setDurationUnit] = useState<number>(1)

  const units: { [key: number]: string } = {
    1: 'Minuter',
    60: 'Timmar',
    1440: 'Dagar',
    10080: 'Veckor',
  }

  const handleUnitChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newUnit = Number(e.target.value)
    setDurationUnit(newUnit)

    // Recalculate value based on new unit
    if (value > 0) {
      const currentBaseValue = value / durationUnit
      onChange(currentBaseValue * newUnit)
    }
  }

  const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === '') {
      onChange(0)
    } else {
      const numericValue = Number(e.target.value)
      if (numericValue) {
        onChange(numericValue * durationUnit)
      }
    }
  }

  // Calculate display value
  const displayValue = value > 0 ? (value / durationUnit).toString() : ''

  return (
    <div className={styles.headerAlignedRow}>
      <div className={styles.headerAlignedLabel}>Tid</div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <input
          type="text"
          pattern="[0-9]+"
          value={displayValue}
          onChange={handleValueChange}
          disabled={disabled}
          className={styles.unitInput}
          style={{ width: '100px' }}
        />
        <select
          value={durationUnit.toString()}
          onChange={handleUnitChange}
          disabled={disabled}
          className={styles.textInput}
          style={{ minWidth: '150px' }}
        >
          {Object.entries(units).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
